import styled from 'styled-components';

export const TabsList = styled.ul`
    margin: 0;
    padding: 0;
    list-style-type: none;
    overflow: auto;
    white-space: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    border-bottom: none;
    padding-bottom: 15px;
    margin-bottom: -15px;
    -webkit-overflow-scrolling: touch;

    /* stylelint-disable property-no-vendor-prefix */
    -webkit-mask-image: -webkit-linear-gradient(left, rgba(0, 0, 0, 1) calc(100% - 15px), rgba(0, 0, 0, 0));
    /* stylelint-enable property-no-vendor-prefix */
`;

export const ListItem = styled.li`
    display: inline-block;
    margin-right: 15px;
`;
